<template>
  <div>
    <v-card flat>
      <v-tabs v-model="tab">
        <v-tab>{{ $t("$vuetify.printerConfig.installedPrinters") }}</v-tab>
        <v-tab>{{ $t("$vuetify.printerConfig.networkPrinters") }}</v-tab>
        <v-tab>Bixolon</v-tab>
        <v-tab-item>
          <installed-printers-inline
            @addPrinter="onAddPrinter"
            @close="onClose"
          ></installed-printers-inline>
        </v-tab-item>
        <v-tab-item>
          <network-printers-inline
            @addPrinter="onAddPrinter"
            @close="onClose"
          ></network-printers-inline>
        </v-tab-item>
        <v-tab-item>
          <bixolon-printers-inline @addPrinter="onAddPrinter" @close="onClose">
          </bixolon-printers-inline>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
// import * as JSPM from 'jsprintmanager'
import { df } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
// import { jspmWSStatus } from '@/libs/jsPrintManager/utils.js'
import InstalledPrintersInline from '@/modules/point-of-sale/components/printer-configuration/Jspm/InstalledPrintersInline.vue'
import NetworkPrintersInline from '@/modules/point-of-sale/components/printer-configuration/Jspm/NetworkPrintersInline.vue'
import BixolonPrintersInline from '@/modules/point-of-sale/components/printer-configuration/Jspm/BixolonPrintersInline.vue'
export default {
  components: {
    InstalledPrintersInline, NetworkPrintersInline, BixolonPrintersInline
  },
  props: {
    location: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tab: null,
      printers: []
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },

    async getPrintersFromDatabase () {
      const printersRef = await df.collection(`location_printers/${this.location.id}/printers`).get()
      this.printers = printersRef.docs.map(doc => doc.data())
    },

    async onAddPrinter (printer) {
      await this.getPrintersFromDatabase()

      if (this.printers.findIndex(p => p.name === printer.name) === -1) {
        const printerId = uuidv4()
        const docRef = df.doc(`location_printers/${this.location.id}/printers/${printerId}`)

        try {
          await docRef.set(
            {
              id: printerId,
              name: printer.name,
              ip_address: printer.ipAddress,
              port: printer.port,
              printer_name: printer.printerName,
              library: printer.library,
              font: printer.font,
              size: printer.size,
              width: printer.width,
              line_length: printer.lineLength,
              char_table: printer.charTable,
              code_page: printer.codePage,
              euro_symbol_type: printer.euroSymbolType
            }
          )
          console.log('Printer successfully saved.')
        } catch (err) {
          console.error('Error saving printer: ', err)
        }
      }
      this.onClose()
    }
  },
  mounted () {
    // this.initPrintManager()
    this.getPrintersFromDatabase()
  }
}
</script>

<style>
</style>
